import script from "./Popup.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popup.vue?vue&type=script&setup=true&lang=ts"

import "./Popup.vue?vue&type=style&index=0&id=69a9f64c&lang=scss"

const __exports__ = script;

export default __exports__